import { useTextes } from '@common/config';
import { DateISO } from '@common/services/src/common/types';
import { DateUtils } from '@common/utils';
import React from 'react';

export const CampagneInformations = ({
                                       annee, dateDebutInscription, dateOuvertureDepot,
                                       dateClotureDepot,
                                     }: CampagneInformationsProps) => {

  const t = useTextes('ParcoursOfa', 'Campagne');

  const campagneInfos = [
    {
      title: 'Année de la campagne',
      text: annee,
    },
    {
      title: 'Date d\'ouverture des inscriptions',
      text: DateUtils.formatDdMmYyyy(dateDebutInscription),
    },
    {
      title: 'Date d\'ouverture des dépôts',
      text: DateUtils.formatDdMmYyyy(dateOuvertureDepot),
    },
    {
      title: 'Date de clôture',
      text: DateUtils.formatDdMmYyyy(dateClotureDepot),
    }];

  return (
    <div className={'fr-card w-full'}>
      <div className={'flex flex-col px-8 py-8 gap-6'}>
        <div className={'flex items-center gap-4'}>
          <div className={'flex-col'}>
            <h6 style={{ marginBottom: '8px' }}>{t['TDB_OFA_TEXTE1']}</h6>
          </div>
        </div>
        <div className={'flex flex-wrap gap-12'}>
          {campagneInfos.map((el, index) => (
            <div key={`${el.title}-${index}`} className={'flex flex-col'}>
              <span className={'text-(--text-label-blue-france)'}>{el.title}</span>
              <span className={'text-(--text-title-grey)'}>{el.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>

  );
};

export interface CampagneInformationsProps {
  annee: number
  dateDebutInscription: DateISO,
  dateOuvertureDepot: DateISO,
  dateClotureDepot: DateISO
}